import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield, FileText } from 'lucide-react';
import SEO, { SEO_CONFIG } from '@/components/SEO';

const KVKKPage = () => {
  return (
    <div className="min-h-screen pt-20 bg-gradient-to-b from-purple-50 via-white to-purple-50">
      <SEO {...SEO_CONFIG.kvkk} />
      {/* Hero */}
      <section className="py-12 bg-gradient-to-r from-purple-600 to-purple-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Shield className="h-12 w-12 mx-auto mb-4 opacity-90" />
          <h1 className="text-3xl sm:text-4xl font-bold mb-2">KVKK Aydınlatma Metni</h1>
          <p className="text-white/80">6698 Sayılı Kişisel Verilerin Korunması Kanunu</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Card>
          <CardContent className="prose prose-purple max-w-none p-8">
            <p className="text-sm text-gray-500 mb-6">Son güncelleme: 12 Aralık 2024</p>

            <h2 className="text-xl font-bold text-purple-800 mt-8 mb-4">1. Veri Sorumlusu</h2>
            <p>
              6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında, kişisel verileriniz; 
              veri sorumlusu olarak <strong>Pilatika Wellness Platform</strong> ("Şirket") tarafından 
              aşağıda açıklanan kapsamda işlenebilecektir.
            </p>

            <h2 className="text-xl font-bold text-purple-800 mt-8 mb-4">2. Kişisel Verilerin İşlenme Amacı</h2>
            <p>Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Üyelik işlemlerinin gerçekleştirilmesi ve hesap yönetimi</li>
              <li>Ders ve eğitim hizmetlerinin sunulması</li>
              <li>Ödeme işlemlerinin gerçekleştirilmesi</li>
              <li>Müşteri ilişkileri yönetimi ve destek hizmetleri</li>
              <li>Yasal yükümlülüklerin yerine getirilmesi</li>
              <li>İstatistiksel analizler ve hizmet iyileştirme</li>
              <li>Pazarlama ve tanıtım faaliyetleri (açık rızanız dahilinde)</li>
            </ul>

            <h2 className="text-xl font-bold text-purple-800 mt-8 mb-4">3. İşlenen Kişisel Veriler</h2>
            <p>Platformumuz tarafından işlenen kişisel veri kategorileri:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Kimlik Bilgileri:</strong> Ad, soyad</li>
              <li><strong>İletişim Bilgileri:</strong> E-posta adresi, telefon numarası</li>
              <li><strong>Hesap Bilgileri:</strong> Kullanıcı adı, şifre (şifrelenmiş)</li>
              <li><strong>Finansal Bilgiler:</strong> Ödeme bilgileri (iyzico üzerinden işlenir)</li>
              <li><strong>Kullanım Verileri:</strong> Ders geçmişi, ilerleme bilgileri</li>
              <li><strong>Teknik Veriler:</strong> IP adresi, tarayıcı bilgileri, çerezler</li>
            </ul>

            <h2 className="text-xl font-bold text-purple-800 mt-8 mb-4">4. Kişisel Verilerin Aktarımı</h2>
            <p>Kişisel verileriniz, aşağıdaki taraflara aktarılabilir:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Ödeme işlemleri için iyzico Ödeme Hizmetleri A.Ş.</li>
              <li>Hosting ve bulut hizmet sağlayıcıları</li>
              <li>Yasal zorunluluk halinde yetkili kamu kurum ve kuruluşları</li>
            </ul>

            <h2 className="text-xl font-bold text-purple-800 mt-8 mb-4">5. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi</h2>
            <p>
              Kişisel verileriniz; web sitemiz, mobil uygulamamız ve diğer dijital kanallar aracılığıyla, 
              otomatik veya otomatik olmayan yöntemlerle toplanmaktadır. Hukuki sebepler:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Açık rızanızın bulunması (KVKK m.5/1)</li>
              <li>Sözleşmenin kurulması veya ifası için gerekli olması (KVKK m.5/2-c)</li>
              <li>Veri sorumlusunun hukuki yükümlülüğü (KVKK m.5/2-ç)</li>
              <li>Meşru menfaatler için zorunlu olması (KVKK m.5/2-f)</li>
            </ul>

            <h2 className="text-xl font-bold text-purple-800 mt-8 mb-4">6. Kişisel Veri Sahibinin Hakları</h2>
            <p>KVKK'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
              <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
              <li>Kişisel verilerinizin işlenme amacını öğrenme</li>
              <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
              <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde düzeltilmesini isteme</li>
              <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde silinmesini isteme</li>
              <li>Düzeltme ve silme işlemlerinin aktarılan üçüncü kişilere bildirilmesini isteme</li>
              <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
              <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme</li>
            </ul>

            <h2 className="text-xl font-bold text-purple-800 mt-8 mb-4">7. Veri Güvenliği</h2>
            <p>
              Kişisel verilerinizin güvenliği için gerekli teknik ve idari tedbirler alınmaktadır:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>SSL/TLS şifreleme ile güvenli veri iletimi</li>
              <li>Şifrelerin tek yönlü hash algoritmaları ile saklanması</li>
              <li>Düzenli güvenlik denetimleri</li>
              <li>Erişim kontrolü ve yetkilendirme</li>
            </ul>

            <h2 className="text-xl font-bold text-purple-800 mt-8 mb-4">8. Saklama Süresi</h2>
            <p>
              Kişisel verileriniz, işleme amacının gerektirdiği süre boyunca ve yasal saklama 
              süreleri dahilinde muhafaza edilir. Üyelik sona erdikten sonra yasal zorunluluklar 
              kapsamında gerekli süre boyunca saklanır.
            </p>

            <h2 className="text-xl font-bold text-purple-800 mt-8 mb-4">9. Başvuru Yöntemi</h2>
            <p>
              KVKK kapsamındaki haklarınızı kullanmak için aşağıdaki yöntemlerle başvurabilirsiniz:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>E-posta:</strong> kvkk@pilatika.com</li>
              <li><strong>Posta:</strong> Levent Mah. Büyükdere Cad. No:123, Beşiktaş/İstanbul</li>
            </ul>
            <p className="mt-4">
              Başvurunuz en geç 30 gün içinde ücretsiz olarak sonuçlandırılacaktır. 
              İşlemin ayrıca bir maliyet gerektirmesi halinde Kişisel Verileri Koruma Kurulu 
              tarafından belirlenen tarife uygulanacaktır.
            </p>

            <div className="mt-8 p-4 bg-purple-50 rounded-lg">
              <p className="text-sm text-purple-800">
                <strong>İletişim:</strong><br />
                Pilatika Wellness Platform<br />
                E-posta: kvkk@pilatika.com<br />
                Telefon: +90 (212) 123 45 67
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default KVKKPage;
